var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectPlayerProfilePictureName } from "../../balancingSelectors/selectBalancingPictures";
import { IdStyles } from "../../less/IdStyles";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { selectRankingLevelFromXp } from "../../selectors/selectPlayerLevelInfo";
import { selectRankEntry, selectRankingSelectedLanguage, selectRankingSelfName, selectSelfEntry, } from "../../selectors/selectRankInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { Table } from "../generic/table/Table";
import { IdModal } from "../modals/IdModal";
import { actionOpenOtherPlayerProfile, actionOpenOwnPlayerProfile, } from "../player-profile/actionPlayerProfile";
import { HOCRanking } from "./HOCRanking";
import { PlayerRankingCategory } from "./PlayerRankingCategory";
import { RankingButtons } from "./RankingButtons";
import { RankTableRow } from "./RankTableRow";
var RankingBodyDOM = /** @class */ (function (_super) {
    __extends(RankingBodyDOM, _super);
    function RankingBodyDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.RankTableHeaders = [
            utilLoca.get(IdLoca.rankingMenu_rank),
            utilLoca.get(IdLoca.rankingMenu_name),
            utilLoca.get(IdLoca.rankingMenu_level),
        ];
        _this.getTableHeaders = function () {
            var headers = [];
            _this.RankTableHeaders.map(function (head, index) {
                var nameColClassName = head === utilLoca.get(IdLoca.rankingMenu_name) ? "td--pp" : "";
                headers.push(React.createElement(React.Fragment, { key: "th-" + index },
                    React.createElement("div", { className: "td " + nameColClassName }, head),
                    React.createElement("div", { className: "td__divider" })));
            });
            headers.push(React.createElement("div", { className: "td", key: "th-" + _this.RankTableHeaders.length },
                React.createElement(Icon, { icon: _this.getRankingIcon(), styleId: IdStyles.IconSmall })));
            return headers;
        };
        _this.getRankingIcon = function () {
            var activeTabIndex = _this.props.activeTabIndex;
            switch (activeTabIndex) {
                case PlayerRankingCategory.AdventurerLevelRanking:
                    return IdIcon.XpAdventureIcn;
                case PlayerRankingCategory.CoopLevelRanking:
                    return IdIcon.CoopXpIcn;
                case PlayerRankingCategory.PlayerLevelRanking:
                default:
                    return IdIcon.XpIcn;
            }
        };
        _this.getTableRows = function () {
            var rows = [];
            var _a = _this.props, rankingEntry = _a.rankingEntry, getLevelFromXp = _a.getLevelFromXp, selfEntry = _a.selfEntry, activeTabIndex = _a.activeTabIndex, onPlayerRowClick = _a.onPlayerRowClick, onSelfClick = _a.onSelfClick;
            var playerId = selfEntry ? Long.fromValue(selfEntry.id) : undefined;
            if (rankingEntry) {
                rankingEntry.map(function (RankingParam) {
                    var id = RankingParam.id, position = RankingParam.position, name = RankingParam.name, xp = RankingParam.xp, profilePictureId = RankingParam.profilePictureId;
                    var rowClassName = _this.getRowClassName(playerId, Long.fromValue(id), position);
                    var idKey = id.toString();
                    var level = xp ? getLevelFromXp(Long.fromValue(xp)) : 0;
                    var profilePictureName = activeTabIndex === PlayerRankingCategory.CoopLevelRanking
                        ? undefined
                        : selectPlayerProfilePictureName(profilePictureId);
                    var onClick = activeTabIndex === PlayerRankingCategory.PlayerLevelRanking
                        ? (playerId || Long.ZERO).equals(id)
                            ? onSelfClick
                            : function () { return onPlayerRowClick(id); }
                        : undefined;
                    rows.push(React.createElement(RankTableRow, { rank: position, name: name, level: level, profilePictureName: profilePictureName, rankValue: xp, rowClassName: rowClassName, key: idKey, onRowClick: onClick }));
                });
            }
            return rows;
        };
        _this.getRowClassName = function (currentPlayerId, rankPlayerId, rank) {
            if (rank === 1) {
                return IdStyles.TableRowRankingBigGold;
            }
            if (rank === 2) {
                return IdStyles.TableRowRankingBigSilver;
            }
            if (rank === 3) {
                return IdStyles.TableRowRankingBigBronze;
            }
            if (currentPlayerId && currentPlayerId.equals(rankPlayerId)) {
                return IdStyles.TableRowRankingBigSelected;
            }
            return IdStyles.TableRowRankingBig;
        };
        _this.getSelfRow = function () {
            var _a = _this.props, selfEntry = _a.selfEntry, getLevelFromXp = _a.getLevelFromXp, selectedLanguage = _a.selectedLanguage, onSelfClick = _a.onSelfClick, activeTabIndex = _a.activeTabIndex;
            if (!selfEntry ||
                (selectedLanguage && selectedLanguage !== utilLoca.getCurrentLanguage())) {
                return React.createElement("div", null);
            }
            var position = selfEntry.position, name = selfEntry.name, xp = selfEntry.xp, profilePictureId = selfEntry.profilePictureId;
            var level = xp ? getLevelFromXp(Long.fromValue(xp)) : 0;
            var profilePictureName = activeTabIndex === PlayerRankingCategory.CoopLevelRanking
                ? undefined
                : selectPlayerProfilePictureName(profilePictureId);
            var onClick = activeTabIndex === PlayerRankingCategory.PlayerLevelRanking ? onSelfClick : undefined;
            return (React.createElement(RankTableRow, { rank: position, name: name, level: level, profilePictureName: profilePictureName, rankValue: xp, rowClassName: IdStyles.TableRowRankingBigSelected, onRowClick: onClick }));
        };
        var _a = _this.props, onRankingRequest = _a.onRankingRequest, name = _a.name;
        onRankingRequest(name, undefined);
        return _this;
    }
    RankingBodyDOM.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.activeTabIndex !== this.props.activeTabIndex) {
            var _a = this.props, onRankingRequest = _a.onRankingRequest, name = _a.name;
            onRankingRequest(name, undefined);
        }
    };
    RankingBodyDOM.prototype.render = function () {
        var _a = this.props, selfEntry = _a.selfEntry, selectedLanguage = _a.selectedLanguage;
        var isSelfEntryBtnDisabled = selfEntry == undefined ||
            (selectedLanguage && selectedLanguage !== utilLoca.getCurrentLanguage());
        var headers = this.getTableHeaders();
        var rows = this.getTableRows();
        var selfRow = this.getSelfRow();
        return (React.createElement("div", { className: "flex flex__full flex--around v-padding__small" },
            React.createElement(Table, { headers: headers, rows: rows, selfRow: selfRow, tableContainerClassName: IdStyles.RankingListContainer }),
            React.createElement(RankingButtons, { selfEntryBtnDisable: isSelfEntryBtnDisabled })));
    };
    return RankingBodyDOM;
}(React.Component));
var mapState = function (state) { return ({
    activeTabIndex: selectModalTabId(state, IdModal.PlayerRanking),
    getLevelFromXp: function (xp) { return selectRankingLevelFromXp(state, xp); },
    name: selectRankingSelfName(state),
    rankingEntry: selectRankEntry(state),
    selectedLanguage: selectRankingSelectedLanguage(state).languageCode,
    selfEntry: selectSelfEntry(state),
}); };
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onPlayerRowClick: actionOpenOtherPlayerProfile,
        onSelfClick: actionOpenOwnPlayerProfile,
    }, dispatch);
};
export var RankingBody = connect(mapState, mapDispatch)(HOCRanking(RankingBodyDOM));



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/RankingBody.tsx
// module id = 2742
// module chunks = 3